var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M28.9,16.1l-3.9,4v-4.8C25,9,20,4,13.8,4S2.5,9,2.5,15.2s5.1,11.2,11.3,11.2H14v-3h-0.2 c-4.6,0-8.3-3.7-8.3-8.2S9.2,7,13.8,7s8.2,3.7,8.2,8.2v4.8L18.2,16L16,18.1l7.4,7.9l7.6-7.8L28.9,16.1z M23.3,21.5h0.3l-0.2,0.2 L23.3,21.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.df0d9522e116a8e5ba73bd692079775c.svg";
export { ForwardRef as ReactComponent };